import classnames from 'classnames';
import PropTypes from 'prop-types';

import Icon, { GLYPHS } from '../../../../../common/icon';
import { ELIGIBILITY_STEP_STATUS } from '../../constants';
import KnowledgeArticleLink from '../../../../../common/KnowledgeArticleLink';
import { statusClassName } from '../../utils';
import { eligibilityStatus } from '../../propTypes';

const AutoPayoutEligibilityStep = ({
  status,
  name,
  description,
  knowledgeArticleUrl,
  onEligibilityActionClicked,
  eligibilityActionDescription,
}) => (
  <>
    <div className={classnames('c-autopayout__step-status', statusClassName(status))}>
      <Icon glyph={status === ELIGIBILITY_STEP_STATUS.DONE ? GLYPHS.check : GLYPHS.exclamation} />
    </div>

    <div>
      <div className="c-heading--small c-heading--dark u-type--semibold">
        {name}
        {' '}
        <KnowledgeArticleLink url={knowledgeArticleUrl} display-if={knowledgeArticleUrl} />
      </div>
      <div className="c-heading--small c-autopayout__description">
        {description}
      </div>
      <button
        className="c-btn c-btn--blank c-btn--link u-fontsize-extrasmall u-ph0"
        type="button"
        onClick={onEligibilityActionClicked}
        display-if={status !== ELIGIBILITY_STEP_STATUS.DONE}
      >
        {eligibilityActionDescription}
      </button>
    </div>
  </>
);

AutoPayoutEligibilityStep.propTypes = {
  name: PropTypes.string.isRequired,
  status: eligibilityStatus.isRequired,
  description: PropTypes.string.isRequired,
  knowledgeArticleUrl: PropTypes.string.isRequired,
  onEligibilityActionClicked: PropTypes.func.isRequired,
  eligibilityActionDescription: PropTypes.string.isRequired,
};

export default AutoPayoutEligibilityStep;
